import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './Certificates.css';

export default function Certificates() {
  const [certs, setCerts]     = useState([]);
  const [search, setSearch]   = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/certificates').then(r => setCerts(r.data.certificates)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = certs.filter(c =>
    c.productName?.toLowerCase().includes(search.toLowerCase()) ||
    c.batchId?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="page-hero">
        <div className="container">
          <h1>Testing & Certificates</h1>
          <p>Every batch independently tested. All COAs available for download.</p>
        </div>
      </div>

      <div className="container section">
        {/* Why it matters */}
        <div className="cert-why grid-4" style={{ marginBottom: '3rem' }}>
          {[['🔬','HPLC Analysis','High-Performance Liquid Chromatography confirms purity ≥99%'],['⚗️','Mass Spectrometry','Molecular weight verified against known peptide standards'],['🧫','Sterility Testing','Microbial and endotoxin testing on every batch'],['📄','Third-Party Labs','Independent accredited labs — Intertek, SGS, LabCorp Research']].map(([icon, title, desc]) => (
            <div key={title} className="cert-card card">
              <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>{icon}</div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>

        {/* Search */}
        <div className="cert-search">
          <input className="form-input" placeholder="Search by product name or batch ID…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>

        {/* Table */}
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="cert-table-wrap card">
            <table className="cert-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Batch ID</th>
                  <th>Purity</th>
                  <th>Test Date</th>
                  <th>Laboratory</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={7} className="cert-empty">No certificates found matching your search.</td></tr>
                ) : filtered.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.productName}</strong></td>
                    <td><code>{c.batchId}</code></td>
                    <td><span className="badge badge-green">{c.purity}</span></td>
                    <td>{new Date(c.testDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                    <td>{c.lab}</td>
                    <td><span className={`badge ${c.status === 'Passed' ? 'badge-green' : 'badge-red'}`}>✓ {c.status}</span></td>
                    <td>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button className="btn btn-sm btn-secondary">View</button>
                        <button className="btn btn-sm btn-primary">Download</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
